import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FadeView, Icon, LoadingDots, theme } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import {
  useContactUsHandler,
  useKustomerAvailability,
} from '../../../../../integrations/kustomer';
import { AccountMenuPrimaryItem } from '../AccountMenuPrimaryItem';
import { AccountMenuSecondaryItem } from '../AccountMenuSecondaryItem';

export const AccountContactUsOption = (props: AccountContactUsOptionProps) => {
  const { isSecondaryMenuVisible } = props;
  const { t } = useLocalizationContext();

  const isKustomerAvailable = useKustomerAvailability();

  const { handleContactUs, handlingContactUs } = useContactUsHandler(
    isKustomerAvailable,
    'account',
  );

  const AccountMenuItem = isSecondaryMenuVisible
    ? AccountMenuSecondaryItem
    : AccountMenuPrimaryItem;

  return (
    <View style={styles.row}>
      <AccountMenuItem
        testID="account.sidebar-tab.contact-us"
        label={t('account.sidebar.contact-us')}
        iconName="IconText"
        onPress={handleContactUs}
      />
      {!isKustomerAvailable ? (
        <View style={styles.kustomerIcon}>
          <Icon name="IconShare2" />
        </View>
      ) : null}
      <FadeView show={handlingContactUs} style={styles.kustomerIcon}>
        <LoadingDots />
      </FadeView>
    </View>
  );
};

type AccountContactUsOptionProps = {
  readonly isSecondaryMenuVisible?: boolean;
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  kustomerIcon: {
    marginLeft: theme.spacing.small,
  },
});
